import React, { useState, useEffect } from "react";
import { Toast } from "../../CustomComponent/toast";
import performRequest from "../../api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { useNavigate } from "react-router-dom";
import { IoMdContact } from "react-icons/io";

const CricketStartPage = () => {
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [dummyPlayers, setDummyPlayers] = useState([]);
  const navigate = useNavigate();

  const handlePlayerSelect = (id) => {
    setSelectedPlayers((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((playerId) => playerId !== id)
        : [...prevSelected, id]
    );
  };

  useEffect(() => {
    performRequest("GET", "/players/getPlayers")
      .then((res) => {
        if (res.status === 200) {
          setDummyPlayers(res.data);
        } else {
          Toast("error", "Error while getting players!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const createMatch = async () => {
    if (selectedPlayers.length < 2) {
      alert("Select at least 2 players to form teams!");
      return;
    }

    let selectedData = dummyPlayers.filter((player) =>
      selectedPlayers.includes(player.id)
    );

    let shuffledPlayers = [...selectedData].sort(() => 0.5 - Math.random());
    let mid = Math.floor(shuffledPlayers.length / 2);

    const teamA = shuffledPlayers
      .slice(0, mid)
      .map((player) => ({ ...player, team: "A" }));
    const teamB = shuffledPlayers
      .slice(mid)
      .map((player) => ({ ...player, team: "B" }));

    try {
      const headers = { "Content-Type": "application/json" };
      performRequest("POST", `/match/create-match`, { teamA, teamB }, headers)
        .then((res) => {
          if (res.status === 201) {
            Toast("success", "Match created successfully!");
            navigate("/show-teams");
          } else {
            Toast("error", "Error while creating match");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    } catch (err) {
      console.error("Error:", err);
      CustomErrorResponse(err);
    }
  };

  return (
    <div className="container">
      <div
        className="mt-4 p-2 bg-light shadow-lg rounded"
        style={{ height: "610px" }}
      >
        <h2 className="text-center mt-2">🏏 Virtual Cricket Match</h2>

        <h3 className="mt-0">Select Players :</h3>
        <div
          className="card p-3"
          style={{ height: "450px", overflow: "scroll" }}
        >
          {dummyPlayers.map((player) => (
            <div
              key={player.id}
              className="form-check d-flex align-items-center gap-3 mb-5"
            >
              <input
                type="checkbox"
                className="form-check-input mt-1"
                id={`player-${player.id}`}
                checked={selectedPlayers.includes(player.id)}
                onChange={() => handlePlayerSelect(player.id)}
                style={{ height: "30px", width: "30px" }}
              />

              {player?.image ? (
                <img
                  src={player?.image}
                  alt={player?.name}
                  className="rounded-circle border mb-3 mt-3"
                  style={{ height: "40px", width: "40px", objectFit: "cover" }}
                />
              ) : (
                <IoMdContact  style={{ height: "40px", width: "40px", objectFit: "cover" }}></IoMdContact>
              )}

              <label
                className="form-check-label"
                htmlFor={`player-${player.id}`}
                style={{ fontSize: "20px", fontWeight: "500" }}
              >
                {player.name}
              </label>
            </div>
          ))}
        </div>

      
        <button
          className="btn btn-success shadow-sm mt-3 mb-5"
          onClick={createMatch}
        >
          Create Match
        </button>
      </div>
    </div>
  );
};

export default CricketStartPage;
